export default function PageHero({ eyebrow, title, italic, body, testId = "page-hero" }) {
  return (
    <section className="pt-32 md:pt-40 pb-16 md:pb-24 bg-canvas" data-testid={testId}>
      <div className="container-x">
        {eyebrow && <div className="label-eyebrow">{eyebrow}</div>}
        <h1 className="mt-5 font-display font-medium text-forest text-4xl sm:text-5xl md:text-6xl lg:text-[6.4vw] leading-[0.95] tracking-tightest max-w-5xl">
          {title}{" "}
          {italic && (
            <>
              <br className="hidden md:block" />
              <span className="italic font-serif text-forest/80">{italic}</span>
            </>
          )}
        </h1>
        {body && (
          <p className="mt-6 md:mt-8 max-w-2xl text-base sm:text-lg text-ink/70 leading-relaxed">
            {body}
          </p>
        )}
      </div>
    </section>
  );
}
